import { useContext } from 'react'
import contextViewport, { ViewportTypeValues } from '@contexts/viewport'

const { ViewportTypeContext } = contextViewport

const useViewportType = (): ViewportTypeValues => {
  const viewportType = useContext(ViewportTypeContext)

  return viewportType
}

export default useViewportType
